import BASE_URL from "../config";

// The refresh token itself is never touched here — it lives in an
// HttpOnly cookie the backend sets/reads automatically. `credentials:
// "include"` is what makes the browser actually send/store that cookie on
// these specific calls (cross-origin in local dev: localhost:3000 vs
// localhost:5000).
const request = async (path, options = {}) => {
  const response = await fetch(`${BASE_URL}${path}`, {
    credentials: "include",
    headers: { "Content-Type": "application/json", ...(options.headers || {}) },
    ...options,
  });
  const data = await response.json().catch(() => ({}));
  return { ok: response.ok, status: response.status, data };
};

// Whether sign-in currently includes the mobile OTP step (the backend's PHONE_OTP_REQUIRED switch).
export const getAuthConfig = () => request("/auth/config");

export const login = (email, password) =>
  request("/auth/login", { method: "POST", body: JSON.stringify({ email, password }) });

// Phone-OTP step for customers. `challengeToken` comes from login/signup when the
// number still has to be verified.
export const sendOtp = (challengeToken, phone) =>
  request("/auth/otp/send", { method: "POST", body: JSON.stringify({ challengeToken, phone }) });

export const verifyOtp = (challengeToken, code, phone) =>
  request("/auth/otp/verify", { method: "POST", body: JSON.stringify({ challengeToken, code, phone }) });

export const signup = (payload) =>
  request("/auth/signup", { method: "POST", body: JSON.stringify(payload) });

// Exchanges the HttpOnly refresh cookie for a new access token. Called
// automatically before the previous access token's ~15 min lifetime runs
// out, so a logged-in tab never gets silently signed out.
export const refreshAccessToken = () => request("/auth/refresh", { method: "POST" });

export const logout = () => request("/auth/logout", { method: "POST" });

export const changePassword = (currentPassword, newPassword, token) =>
  request("/auth/change-password", {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
    body: JSON.stringify({ currentPassword, newPassword }),
  });

// Access tokens are short-lived by design (see JWT_ACCESS_EXPIRATION on the
// backend) — refresh a little before actual expiry so a request in flight
// doesn't race a 401. Falls back to a fixed interval if exp isn't decodable.
const DEFAULT_REFRESH_INTERVAL_MS = 12 * 60 * 1000;

export const scheduleTokenRefresh = (onRefreshed, intervalMs = DEFAULT_REFRESH_INTERVAL_MS) => {
  const timer = setInterval(async () => {
    try {
      const { ok, data } = await refreshAccessToken();
      if (ok && data?.data?.token) {
        onRefreshed(data.data.token, data.data.user);
      }
    } catch {
      // Backend unreachable - skip this refresh tick, try again next interval.
    }
  }, intervalMs);

  return () => clearInterval(timer);
};











































